(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["footer-policy-list"] && !Shopify.designMode) return;
  try {
    let mariposaPrivacyBannerLoading;

  function mariposaLoadPrivacyBanner() {
    if (typeof window.privacyBanner?.showPreferences === 'function') {
      return Promise.resolve();
    }
    if (mariposaPrivacyBannerLoading) return mariposaPrivacyBannerLoading;
    mariposaPrivacyBannerLoading = new Promise((resolve, reject) => {
      const source = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
      let script = document.querySelector('script[src="' + source + '"]');
      const loaded = () => {
        if (typeof window.privacyBanner?.showPreferences === 'function') resolve();
        else reject(new Error('Privacy preferences unavailable'));
      };
      if (!script) {
        script = document.createElement('script');
        script.src = source;
        script.async = true;
        script.dataset.mariposaPrivacyBanner = 'true';
        script.addEventListener('load', loaded, { once: true });
        script.addEventListener('error', reject, { once: true });
        document.head.appendChild(script);
      } else {
        script.addEventListener('load', loaded, { once: true });
        script.addEventListener('error', reject, { once: true });
      }
      setTimeout(() => reject(new Error('Privacy preferences timed out')), 10000);
    }).catch(error => {
      document.querySelector('script[data-mariposa-privacy-banner="true"]')?.remove();
      mariposaPrivacyBannerLoading = undefined;
      throw error;
    });
    return mariposaPrivacyBannerLoading;
  }

  document.addEventListener('click', async event => {
    const button = event.target instanceof Element
      ? event.target.closest('[data-mariposa-cookie-preferences]')
      : null;
    if (!button || button.disabled) return;
    const status = button.parentElement?.querySelector('[data-mariposa-cookie-status]');
    button.disabled = true;
    if (status) status.hidden = true;
    try {
      await mariposaLoadPrivacyBanner();
      await window.privacyBanner.showPreferences();
    } catch {
      if (status) status.hidden = false;
    } finally {
      button.disabled = false;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
